import { fetch } from 'reactor/components';
import { C } from 'common';
import { Storage, StorageCookie } from 'reactor/common';
import onAgency from './onAgency';

const {
  FETCH_PROPS, STORAGE, COOKIE_DOMAIN, URL,
} = C;
const monthMs = 30 * 24 * 3600 * 1000;

const onLink = async () => window.open(URL.ACTIVITY_SEARCH);

export default async (component, { l10n, onError }) => {
  const {
    props: { onSubmit },
    state: {
      hash,
      signup,
      value: {
        email,
        password,
        agencyId,
        city,
        country,
        document,
        documentId,
        name: agencyName,
        number,
        phone,
        street,
        state,
        socialReason,
        username,
        web,
      } = {},
    },
  } = component;
  let body;

  if (signup) {
    body = {
      agencyId,
      agencyName,
      document: { type: document, value: documentId },
      email,
      invoiceAddress: {
        street, number, city, state, country,
      },
      password,
      phone,
      socialReason,
      web,
    };
  } else {
    body = hash ? { hash } : {
      email,
      password,
      username,
    };
  }

  component.setState({ busy: true });
  const session = await fetch({
    ...FETCH_PROPS,
    method: 'POST',
    service: `agency/${signup ? 'signup' : 'signin'}`,
    body: JSON.stringify(body),
  }).catch(() => {
    onError({ message: l10n.ERROR_SIGNIN_TEXT, title: l10n.ERROR_SIGNIN_TITLE });
  });

  if (session) {
    const { hash: authorization, name, id } = session;
    const store = { authorization, name, id };
    const expires = new Date();
    const time = expires.getTime() + monthMs;
    expires.setTime(time);

    await StorageCookie.set(STORAGE.AGENCY, store, COOKIE_DOMAIN, expires.toUTCString());
    await StorageCookie.set(STORAGE.AFFILIATE, null, COOKIE_DOMAIN);
    await Storage.set(STORAGE.JEFFREY);

    const agency = await onAgency(authorization, { onError });
    if (agency) {
      await StorageCookie.set(STORAGE.CODE, agency.discount, COOKIE_DOMAIN, expires.toUTCString());
    }
    onLink();

    onSubmit(store);
  }

  component.setState({ busy: false });
};
